import zhCN from './json/product.zh_CN.json';
import zhTW from './json/product.zh_TW.json';
import en from './json/product.en.json';
import ja from './json/product.ja.json';
import ko from './json/product.ko.json';
import ru from './json/product.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
